(function () {
  const QUOTE_BUTTON_SELECTOR = ".quotify-request-quote-btn, button[data-quotify]";
  const QUOTE_BLOCK_SELECTOR = "[id^='ProductQuoteButton-']";

  function updateQuotifyButtons(root) {
    const label = window.productsStrings?.requestQuote;
    if (!label) return;

    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(QUOTE_BUTTON_SELECTOR).forEach((button) => {
      button.classList.add("button", "button-secondary");
      button.textContent = label;
    });
  }

  function init() {
    updateQuotifyButtons(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (node.matches?.(QUOTE_BUTTON_SELECTOR)) {
            updateQuotifyButtons(node.parentElement || document);
            return;
          }

          if (node.matches?.(QUOTE_BLOCK_SELECTOR) || node.querySelector?.(QUOTE_BLOCK_SELECTOR)) {
            updateQuotifyButtons(node);
            return;
          }

          if (node.querySelector) {
            updateQuotifyButtons(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener("product:variant-change", () => {
      updateQuotifyButtons(document);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
